import { render } from "./Card2.vue?vue&type=template&id=0b5974eb&ts=true"
import script from "./Card2.vue?vue&type=script&lang=ts"
export * from "./Card2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__